import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { DeleteFilled, EditFilled, EyeFilled,CheckCircleFilled,CloseCircleFilled,MinusCircleFilled } from "@ant-design/icons";
import { Auth } from "../../utils/Auth";
import { message, Spin, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { categoryApi } from "../../api/categoryApi";

const ListCategoriesView = () => {
    const token = Auth.getSessionToken()
    const abortController = new AbortController()
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await categoryApi.getCategories(abortController.signal)
 
            if(!res){
                setLoading(false)
                   return;

            }            
            
            setCategories(res.data)
            setLoading(false)
            // console.log(categories)
 
         } catch (error) {
             console.log(error)

            setLoading(false)
            const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                if(messages.join('\n') === 'Unauthenticated'){
                    Auth.removeSessionToken()
                    return navigate(`/login`)
                }   
               			
              });
 
         }
    }

    const handleDetail = (category) => {
        // console.log("ID mecano",category.id)
        if(category.id)
            return navigate(`/annonces/categories/${category.id}/details`)
        
    }

    const handleAddProvider = (e) => {
        e.preventDefault()

        navigate('/annonces/categories/creation')
    }

    const handleEdit =(category) => {
      if(category.id)
        return navigate(`/annonces/categories/${category.id}/edit`)
    }
    const handleDelete = async (category) => {
        try {
          const res = await categoryApi.deleteCategory(`${category.id}`,abortController.signal)

          if (res.success == true) {
            message.success("Suppression effectuee avec succès !");
          }else{
            message.error(res.message);

          }

          handlefetchdata()
          
        } catch (error) {
          console.error(error);
          setLoading(false);
          message.error("Échec de suppression des informations");
        }
        
        

    }


    useEffect(() => {
        handlefetchdata()

        // console.log('liste get token',token)
    },[])

  return (
    <MainLayout>
      <div className="container mx-auto p-4">
        <h1 className="text-xl font-bold mb-4">Liste des categories d'annonces</h1>

        {/* Bouton Ajouter */}
        <button
          onClick={handleAddProvider}
          className="mb-4 px-4 py-2 text-white bg-africasa-secondary rounded hover:bg-africasa-primary"
        >
          Ajouter une categorie
        </button>

        {/* Table */}
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="py-2 px-4 border-b text-left">#</th>
              <th className="py-2 px-4 border-b text-left">Designation</th>
              <th className="py-2 px-4 border-b text-left">Type</th>
              <th className="py-2 px-4 border-b text-left">Etat</th>
              <th className="py-2 px-4 border-b text-left">Nombre de suivis</th>
              <th className="py-2 px-4 border-b text-left">Description</th>
              <th className="py-2 px-4 border-b text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
                <tr>
                <td colSpan="6" className="text-sm text-center py-4">
                    Chargement des données en cours...
                </td>
                </tr>
            ) : (
                categories.map((category, index) => (
                <tr key={category.id}>
                    <td className="py-2 px-4 border-b">{index + 1}</td>
                    <td className="py-2 px-4 border-b">
                    {category?.libelle} 
                    </td>
                    <td className="py-2 px-4 border-b">{category?.parent_id === 0 && 'Categorie principale'}</td>
                    <td className="py-2 px-4 border-b">{category?.etat === 1 ? 'Actif' : 'inactif'}</td>
                    <td className="py-2 px-4 border-b">{category.is_followed || 0}</td>
                    <td className="py-2 px-4 border-b">
                      {category?.description}



                    </td>
                    <td className="py-2 px-4 border-b">
                    <EyeFilled
                        className="text-green-600 mr-2 cursor-pointer hover:text-green-800"
                        onClick={() => handleDetail(category)}
                    />
                    <EditFilled className="text-blue-600 mr-2 cursor-pointer hover:text-blue-800" 
                      onClick={() => handleEdit(category) }

                    />
                    <DeleteFilled className="text-red-600 cursor-pointer hover:text-red-800"
                      onClick={() => handleDelete(category)}
                    />

                    
                    </td>
                </tr>
                ))
            )}
            </tbody>

        </table>
      </div>
    </MainLayout>
  );
};

export default ListCategoriesView;
